export default "__VITE_ASSET__CWNDp9_Z__"